module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-left-arrow-teal-on-white-b8784b128b0f4fb9912bc5841f0907d4.svg";